const swiperTextVerticalCarousel = {
    swiperInstance: null,
    autoplayDelay: 0,
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-text-vertical-carousel');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    if (el.getAttribute('data-autoplaydelay')) {
                        swiperTextVerticalCarousel.autoplayDelay = el.getAttribute('data-autoplaydelay');
                    } else {
                        swiperTextVerticalCarousel.autoplayDelay = 3000
                    }
                    swiperTextVerticalCarousel.swiperInstance = new Swiper(el, params);

                    // adding autoplay.delay from data-autoplaydelay
                    swiperTextVerticalCarousel.swiperInstance.params.autoplay.delay = swiperTextVerticalCarousel.autoplayDelay

                    // actions on slideChange of main swiper
                    // swiperTextVerticalCarousel.swiperInstance.on('slideChange', function () {
                    //     // let activeIndex = this.realIndex;
                    //     const slider = swiperTextVerticalCarousel.swiperInstance;
                    //     const currentSlide = slider.slides[slider.activeIndex];
                    //     const currentSlideItem = currentSlide.children[0];
                    //     slider.style.height = currentSlideItem.clientHeight + "px";
                    // });
                })
            }
        })
    }
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        direction: 'vertical',
        // autoHeight: true,
        loop: true,
        autoplay: {
            delay: swiperTextVerticalCarousel.autoplayDelay
        },
        speed: 750,
        resizeObserver: true,
        a11y: true,
        allowTouchMove: false, // preventing the touch slide
        watchSlidesProgress: true
    }
}

export default swiperTextVerticalCarousel;